import { AxiosInstance } from 'axios'
import { i18n } from 'i18next'
import _ from 'lodash'
import { applyMiddleware, compose, createStore, Reducer } from 'redux'
import createSagaMiddleware, { Saga } from 'redux-saga'
import { Config } from '@briq/shared'

import { AppConfig } from '../config/configContext'
import { routesConfig } from '../routes/routes'
import { SignalR } from '../utils/signalr'
import { Dictionary } from '../utils/types'

import { getGtmMiddleware } from './gtm'
import { makeRootReducer } from './rootReducer'
import { rootSaga } from './rootSaga'

export interface ReduxStoreConfig {
  customReducers?: Record<string, Reducer>
  customRootSaga?: Saga
  axios: AxiosInstance
  appConfig?: Partial<AppConfig & Config.AppConfig>
  i18Next: i18n
  gtmId?: string
  icons: Dictionary<React.ComponentType<any>>
  images: Dictionary<string>
}

export const makeStore = (config: ReduxStoreConfig) => {
  const rootReducer = makeRootReducer(_.get(config, 'customReducers', {}))

  const sagaMiddleware = createSagaMiddleware({
    context: {
      axios: config.axios,
      i18n: config.i18Next,
      routes: !_.isEmpty(config.appConfig?.routes)
        ? {
            ...routesConfig,
            ...(config.appConfig?.routes || {})
          }
        : routesConfig
    }
  })

  const gtmMiddleware = getGtmMiddleware({ i18n: config.i18Next })

  const composeEnhancers =
    (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

  const middleware = [sagaMiddleware, gtmMiddleware]
  const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)))

  sagaMiddleware.run(rootSaga, config.customRootSaga)

  SignalR.setStore(store)

  return store
}
